/**
 * Add limited view query param to links if lv=true.
 */
import DOMPurify from 'dompurify';

if (window.domReady) {
  window.domReady(() => {
    const queryString = DOMPurify.sanitize(window.location.search);
    const urlParams = new URLSearchParams(queryString);
    if ('true' === urlParams.get('lv')) {
      document.querySelectorAll('a').forEach((anchor) => {
        const href = anchor.getAttribute('href');
        if (href) {
          if (! href.startsWith('//')) {
            const param = href.includes('?') ? '&lv=true' : '?lv=true';
            anchor.setAttribute('href', `${href}${param}`);
          }
        }
      });
    }
  });
}
